import axios from 'axios';

const list = params => axios.get('/locais-entrega', {
  params,
});

const get = id => axios.get(`/locais-entrega/${id}`);

const save = (locaisEntrega) => {
  if (locaisEntrega.id) {
    return axios.put(`/locais-entrega/${locaisEntrega.id}`, locaisEntrega);
  }
  return axios.post('/locais-entrega', locaisEntrega);
};

const remove = id => axios.delete(`/locais-entrega/${id}`);

export default {
  list,
  get,
  save,
  remove,
};
